import React from 'react';
import PropTypes from 'prop-types';
import {DOSSIER_STATE} from 'front-onceforall-core/dist/utils/dossiers';
import ListItemView from './ListItemView';
import documentService from '../../../../services/document/DocumentService';
import {captureError} from '../../../../utils/log';
import config from '../../../../../config';
import SelectClientPanel from './selectClientPanel';

function ListItemContainer({organisation}) {
  const [dossierState, setDossierState] = React.useState(null);
  const [isPanelOpen, setIsPanelOpen] = React.useState(false);

  React.useEffect(() => {
    const aborter = new AbortController();

    if (!organisation.depositor) {
      setDossierState(DOSSIER_STATE.DEPOSITOR_SERVICE_DEACTIVATED);
      return false;
    }

    if (config.featureFlags.noSubcontractorsDossierStateCalls) {
      return false;
    }

    setDossierState(null);

    documentService.getDossierStateForGlobalDashboard(organisation.organisationId, aborter.signal)
      .then(response => {
        setDossierState(response.dossierState);
      })
      .catch(error => {
        if (error.name !== 'AbortError' && error.response.status !== 400) {
          captureError('Error while fetching subcontractor dossier state', error);
        }
      });

    return () => {
      aborter.abort();
    };
  }, [organisation]);

  return (
    <>
      <ListItemView
        organisation={organisation}
        onClickOrganisation={() => setIsPanelOpen(true)}
        dossierState={dossierState}
      />
      <SelectClientPanel
        isOpen={isPanelOpen}
        organisation={organisation}
        onClose={() => setIsPanelOpen(false)}
      />
    </>
  );
}

ListItemContainer.propTypes = {
  organisation: PropTypes.object.isRequired
};

export default ListItemContainer;
